import { MarkerClusterer } from '@googlemaps/markerclusterer';

export function initializeMarkerCluster(map, markers) {
    return new MarkerClusterer({ map, markers });
}
